import { Ok } from '@core/model/framework/Result/OkResult';
import { AccountService } from '@core/model/service/accountService';
import { GetCaseStateInput, GetCaseStateOutput } from '@core/usecase/getCaseState';
import { injectable } from 'inversify';

@injectable()
export class IMAccountService implements AccountService {
  async getCaseState(input: GetCaseStateInput): GetCaseStateOutput {
    switch (input.userId) {
      case 'RETRY_ACCOUNT':
        return Ok('RETRY_ACCOUNT');
      case 'IN_PROGRESS':
        return Ok('IN_PROGRESS');
      case 'SUCCESS':
        return Ok('SUCCESS');
      case 'FAILED':
        return Ok('FAILED');
      case 'THROW':
      default:
        throw new Error('unexpected value');
    }
  }
}
